import {Box, Grid, Pillar} from '@primer/react-brand/esm'
import {getPrimerIcon} from '@github-ui/swp-core/lib/utils/icons'
import {clsx} from 'clsx'
import type {IconItem} from '../../types'
import {renderPillarHeading, renderWithoutParagraphs} from '../../utils'
import baseStyles from '../../styles/base.module.css'

export type FlexSuiteIntroPillarsProps = {
  introPillars?: IconItem[]
  promoteFirstHeading?: boolean
}

export function FlexSuiteIntroPillars({introPillars, promoteFirstHeading = false}: FlexSuiteIntroPillarsProps) {
  if (!introPillars || introPillars.length === 0) return null

  const firstHeadingIndex = introPillars.findIndex(item => Boolean(item.fields.heading))

  const pillarItems = introPillars.map((item, index) => {
    const IconComponent = item.fields.icon ? getPrimerIcon(item.fields.icon) : null
    return (
      <Grid.Column
        key={item.sys.id}
        span={{xsmall: 12, xlarge: 4}}
        // eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals
        className="gridColumn"
      >
        <Box
          className={clsx(baseStyles.cardGridItem, baseStyles.stackedCardGridItem)}
          padding={{narrow: 24, regular: 40, wide: 64}}
          paddingInlineStart={{narrow: 24, regular: 80, wide: 64}}
          paddingInlineEnd={{narrow: 24, regular: 80, wide: 64}}
          borderWidth="thin"
          borderColor="muted"
        >
          <Pillar fullWidth>
            {IconComponent ? <Pillar.Icon icon={<IconComponent />} /> : null}
            {item.fields.heading && (
              <Pillar.Heading as={index === firstHeadingIndex && promoteFirstHeading ? 'h2' : 'h3'} size="6">
                {renderPillarHeading(item.fields.heading)}
              </Pillar.Heading>
            )}
            {item.fields.description && (
              <Pillar.Description>{renderWithoutParagraphs(item.fields.description)}</Pillar.Description>
            )}
          </Pillar>
        </Box>
      </Grid.Column>
    )
  })

  return (
    <Box className={baseStyles.stackedCardGridSection}>
      <Box className={`${baseStyles.gridFrameTop} ${baseStyles.greenBorderBottom}`}>
        <Grid columnGap="none" rowGap="none" enableGutters={false}>
          <Grid.Column span={{xsmall: 12, medium: 10, xlarge: 12}} start={{medium: 2}}>
            <Grid columnGap="none" rowGap="none" enableGutters={false} className={baseStyles.narrowStackFrame}>
              {pillarItems}
            </Grid>
          </Grid.Column>
        </Grid>
      </Box>
    </Box>
  )
}
